<template>
  <div id="app">
    <menu-layout>
      <router-view name="Home"></router-view>
    </menu-layout>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {};
  },
  methods: {},

  created() {}
};
</script>

<style lang="less">
@import './index.less';
</style>
